<template>
  <section class="banner" :style="{ backgroundImage: `url(${bgUrl})` }">
    <Text color="t1" variant="72" weight="bold" class="font-dt banner-title"> PPT/PDF转视频 </Text>
    <Text color="t5" variant="16" weight="regular" class="banner-sub">
      有言——被百万用户选择的AI视频创作工具
    </Text>
    <div>
      <Create />
    </div>
    <div class="banner-step">
      <Step />
    </div>
  </section>
</template>

<script setup lang="ts">
import { Text } from '@rendora/design/components/text/index';
import Create from './create.vue';
import Step from './step.vue';

const bgUrl = computed(() => {
  return getFeUrl('/youyan-platform/ppt-or-pdf/bg.png');
});
</script>

<style scoped lang="scss">
.banner {
  margin-top: 164px;
  background-size: 1640px 576px;
  background-position: center 66px;
  background-repeat: no-repeat;
}
.banner-title {
  text-align: center;
  margin-bottom: 24px;
}
.banner-sub {
  text-align: center;
  margin-bottom: 60px;
}
.banner-step {
  margin-top: 80px;
}
</style>
